import type {ScanContext} from "../scan-model/ScanContext.tsx";
import {scanVersions} from "./2-ScanVersions.tsx";
import {scanVersionsJobs} from "./3-ScanJobs.ts";
import {scanSharedJobs} from "./1-ScanSharedJobs.tsx";
import {mergeResults} from "./5-MergeResults.tsx";
import {scanTaskHistory} from "./4-ScanTaskHistory.tsx";
import {scanDrivers} from "./1-ScanDrivers.tsx";
import {scanEnvironments} from "./3-ScanEnvironments.ts";
import {scanSchedules} from "./3-ScanSchedules.tsx";
import {scanSupportInfo} from "./1-ScanSupportInfo.tsx";
import {optionalScans} from "./3-OptionalScans.tsx";


export async function performScan(ctx: ScanContext) {
    try {
        ctx.log("Starting scan")
        const supportInfo = await scanSupportInfo(ctx)
        const sharedJobs = await scanSharedJobs(ctx)
        const driverReport = await scanDrivers(ctx)
        const versionsScanPlan = await scanVersions(ctx)
        const optionalInfo = await optionalScans(ctx, versionsScanPlan)
        const scannedEnvs = await scanEnvironments(ctx, versionsScanPlan.versions)
        const scannedJobs = await scanVersionsJobs(ctx, versionsScanPlan.versions)
        const scannedSchedules = await scanSchedules(ctx, versionsScanPlan)
        const scannedTaskHistory = await scanTaskHistory(ctx, scannedJobs)
        const mergedScanResult = mergeResults(ctx, scannedJobs, scannedTaskHistory, driverReport, scannedEnvs, sharedJobs, supportInfo, optionalInfo)
        mergedScanResult.scheduleScan = scannedSchedules
        return mergedScanResult
    } catch(e) {
        ctx.logError("An error occurred during scanning which has prevented continuing.", e)
        throw e
    }
}